
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.996 12v5.002a4.002 4.002 0 004.002 4.002h10.004a4.002 4.002 0 004.002-4.002V6.998a4.002 4.002 0 00-4.002-4.002H12M2.996 6.998V2.996h4.002M13 13L2.996 2.996"}}),_c('path',{attrs:{"d":"M8.999 13H13V9"}})])
          )
        }
      }
    